import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { brandLogoUrl } from '@/assets/brand/urls';
import { publicUrl } from '@/utils/publicUrl';

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-slate-950/95 backdrop-blur-lg shadow-lg shadow-cyan-500/5 border-b border-cyan-500/10' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <h1>
              <img
                src={brandLogoUrl()}
                alt={t('nav.logoAlt')}
                className="h-8 w-auto max-w-[min(16rem,48vw)] object-contain object-left"
              />
            </h1>
          </div>

          <div className="hidden md:flex items-center gap-6">
            <a href="#products" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-300 hover:text-cyan-400'
            }`}>
              {t('nav.products')}
            </a>
            <a href="#services" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-300 hover:text-cyan-400'
            }`}>
              {t('nav.services')}
            </a>
            <a
              href={publicUrl('doc')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-300 hover:text-cyan-400'
              }`}
            >
              {t('nav.doc')}
            </a>
            <a href="#about" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-300 hover:text-cyan-400'
            }`}>
              {t('nav.about')}
            </a>
            <a href="#contact" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-300 hover:text-cyan-400'
            }`}>
              {t('nav.contact')}
            </a>
          </div>

          <button className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
            scrolled ? 'text-white' : 'text-white'
          }`}>
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
